export function VisibleLayers(state = [], action) {
  switch (action.type) {
    case 'SET_VISIBLE_LAYERS': {
      return action.payload
    }
    default:
      return state
  }
}
